import { css } from '@emotion/react'
import { size } from '@twistopayments/design-system/styles'

export const headline = css`
  margin-bottom: ${size[8]};
`
